import React from 'react'
import injectStyles from 'react-jss'
import { Col, Row } from 'react-bootstrap'

import { Dropzone } from '../../../../Components/Form'
import SubmitButton from '../../../../Components/Form/SubmitButton'
import { LinkExternal } from '../../../../Components/LinkExternal'
import { styles } from './styles'

const UploadDeliverabilityReportModalBody = ({
  setFile,
  onSubmit,
  onCancel,
  classes,
  isDisabled,
  isLoading,
}) => (
  <div className={classes.wrapper}>
    <div className={classes.subTitle}>
      Please upload the latest deliverability report
    </div>
    <Row>
      <Col xs={6}>
        <Dropzone
          name="upload-document"
          input={{
            onChange: file => setFile(file[0]),
          }}
          meta={{}}
        />
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <div className={classes.downloadLink}>
          <LinkExternal
            href="https://s3-ap-southeast-2.amazonaws.com/prod-oppizi-cdn/example-deliverability-report.csv"
            target="_blank"
          >
            Download the csv template
          </LinkExternal>{' '}
        </div>
      </Col>
    </Row>
    <Row>
      <div className={classes.footer}>
        <Col xs={6}>
          <SubmitButton value="Cancel" onClick={onCancel} />
        </Col>
        <Col xs={6}>
          <SubmitButton
            disabled={isDisabled || isLoading}
            value="Confirm"
            onClick={onSubmit}
            formSubmitting={isLoading}
          />
        </Col>
      </div>
    </Row>
  </div>
)

export default injectStyles(styles)(UploadDeliverabilityReportModalBody)



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/UploadFile/UploadDeliverabilityReportModalBody/index.js